
export const safeAddress = (address: string | null) => {
  if (address) return "0x" + address.substr(2, address.length - 1).toUpperCase()
  return "0x0"
}
